var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { TrainingSessionStatsDto } from './training-session-stats.dto.js';
import { TrainingSessionWellbeeingHistoryDto } from './training-session-wellbeeing-history.dto.js';
export class UserTrainingSessionStatsFullSizeDto {
    id;
    createdAt;
    updatedAt;
    userId;
    user;
    totalStats;
    monthlyStats;
    weeklyStats;
    wellbeeingHistory;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserTrainingSessionStatsFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], UserTrainingSessionStatsFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], UserTrainingSessionStatsFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserTrainingSessionStatsFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], UserTrainingSessionStatsFullSizeDto.prototype, "user", void 0);
__decorate([
    IsObject(),
    Type(() => TrainingSessionStatsDto),
    Expose(),
    __metadata("design:type", TrainingSessionStatsDto)
], UserTrainingSessionStatsFullSizeDto.prototype, "totalStats", void 0);
__decorate([
    IsObject(),
    Type(() => TrainingSessionStatsDto),
    Expose(),
    __metadata("design:type", TrainingSessionStatsDto)
], UserTrainingSessionStatsFullSizeDto.prototype, "monthlyStats", void 0);
__decorate([
    IsObject(),
    Type(() => TrainingSessionStatsDto),
    Expose(),
    __metadata("design:type", TrainingSessionStatsDto)
], UserTrainingSessionStatsFullSizeDto.prototype, "weeklyStats", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => TrainingSessionWellbeeingHistoryDto),
    __metadata("design:type", TrainingSessionWellbeeingHistoryDto)
], UserTrainingSessionStatsFullSizeDto.prototype, "wellbeeingHistory", void 0);
//# sourceMappingURL=training-session-stats.full-size.dto.js.map